import _classCallCheck from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.map.js";

var MapApplication = /*#__PURE__*/function () {
  function MapApplication() {
    _classCallCheck(this, MapApplication);

    this.vm = null;
    this.map = null;
  }
  /**
   * 初始化地图
   * @param {*} vm 
   */


  _createClass(MapApplication, [{
    key: "initMap",
    value: function initMap(vm) {
      this.vm = vm;
      var container = document.getElementById('map-container'); // console.log(window.esmap)

      this.map = new window.esmap.ESMap({
        container: container,
        //渲染dom
        mapDataSrc: './data',
        //地图数据位置 
        mapThemeSrc: './data/theme',
        //主题数据位置
        visibleFloors: "all",
        //更多初始化参数配置请参考https://www.esmap.cn/escopemap/content/cn/develope/map-config.html
        token: "escope"
      }); //打开地图数据

      this.map.openMapById(this.vm.mapID);
      this.map.showCompass = true; //显示指南针 
      // eslint-disable-next-line no-undef

      var ctlOpt = new esmap.ESControlOptions({
        // eslint-disable-next-line no-undef
        position: esmap.ESControlPositon.RIGHT_TOP,
        //注意：imgURL参数是static目录下图片的路径
        imgURL: "./image/wedgets/"
      });

      var _this = this;

      this.map.on("loadComplete", function () {
        //创建楼层控件
        // eslint-disable-next-line no-undef,no-unused-vars
        var floorControl = new esmap.ESScrollFloorsControl(_this.map, ctlOpt);
      });
    }
    /**
     * 销毁地图
     */

  }, {
    key: "destroyMap",
    value: function destroyMap() {
      this.map.dumpScene();
      this.map = null;
    }
  }]);

  return MapApplication;
}();

export default new MapApplication();